module.exports = __webpack_public_path__ + "static/media/MTH_Low_Impact_Dance_Fitness_3.d9232de6.webp";